import * as React from 'react'

const WarningWhiteIcon = (props: { className?: string }) => {
  return (
    <svg
      className={'icon ' + props.className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.8157 13.25L8.76325 1.47727C8.39369 0.840909 7.59297 0.840909 7.22341 1.47727L0.170967 13.25C-0.260187 13.9818 0.170967 15 0.940884 15H15.0458C15.8157 15 16.2776 13.9818 15.8157 13.25ZM7.99324 12.454C7.46969 12.454 7.06934 12.0404 7.06934 11.4995C7.06934 10.9586 7.46969 10.5449 7.99324 10.5449C8.51678 10.5449 8.91714 10.9586 8.91714 11.4995C8.91714 12.0404 8.51678 12.454 7.99324 12.454ZM8.91714 9.59126C8.91714 9.78217 8.79395 9.90945 8.60917 9.90945H7.3773C7.19252 9.90945 7.06934 9.78217 7.06934 9.59126V5.4549C7.06934 5.26399 7.19252 5.13672 7.3773 5.13672H8.60917C8.79395 5.13672 8.91714 5.26399 8.91714 5.4549V9.59126Z'
        fill='white'
      />
    </svg>
  )
}

export default WarningWhiteIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/WarningWhite.tsx